<template>
  <div>
    <v-server-table
      id="anamnesesTable"
      ref="anamnesesTable"
      name="anamnesesTable"
      :columns="columns"
      :options="tableOptions"
      @loaded="onLoaded"
      @loading="onLoading"
      @row-click="handleRowClicked">
        <span slot="createdAt" class="no-break" slot-scope="props">{{ props.row.createdAt | localTime('YYYY-MM-DD HH:mm') }}</span>
        <span slot="actions" class="no-break" slot-scope="props">
          <va-popover
            placement="top"
            :message="$t('agenda.appointments.delete')">
            <i class="fa fa-trash clickable" @click.prevent.stop="handleDeleteAnamnese(props.row, $event)"/>
          </va-popover>

          <va-popover
            placement="top"
            :message="$t('iframe.actions.clone')">
            <i class="fa-solid fa-copy clickable" @click.prevent.stop="handleCloneAnamnese(props.row, $event)"/>
          </va-popover>
        </span>
    </v-server-table>
    <div class="row justify--end mt-2">
      <va-button @click.prevent="handleCreateAnamnese">{{ $t('evohealth.anamneses.new') }}</va-button>
    </div>

    <ConfirmationModal
      v-if="showDeleteConfirmationModal && selectedAnamnese"
      :title="$t('evohealth.anamneses.delete_title')"
      :body="$t('evohealth.anamneses.delete_body', {title: selectedAnamnese.name})"
      @modal-confirmed="destroyAnamnese"
      @modal-canceled="cancelDestroyAnamnese" />

    <CloneAnamneseModal
      v-if="showCloneModal"
      :anamnese="selectedAnamnese"
      :entities="allowedEntities"
      @cancel="showCloneModal = false"
      @clonedSuccess="cloneSuccessfull"
    />
  </div>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin.vue';
import ConfirmationModal from '@/components/common/ConfirmationModal.vue';
import { EvohealthService } from '@/api/EvohealthService';
import CloneAnamneseModal from '@/components/evohealth/anamneses/CloneAnamneseModal.vue';
import ApiService from '@/api/ApiService';
import axios from "axios";
export default {
  components: { CloneAnamneseModal, ConfirmationModal },
  mixins: [
    TableQueryMixin
  ],
  props: {
    filters: {
      type: Object,
      required: true
    },
    allowedEntities: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      showDeleteConfirmationModal: false,
      showCloneModal: false,
      tableOptions: {
        requestFunction: (data) => {
          const page = data.page
          return new Promise((resolve, reject) => {
            if (this.cancelationCallback !== null) {
              this.cancelationCallback()
            }
            this.isLoading = true
            if(this.filters && this.filters.entity) {
              data.entity = this.filters.entity.id
            }


            const queryUrl = this.queryUrl

            ApiService.cancelableQuery(queryUrl, data, new axios.CancelToken(c => {
              this.cancelationCallback = c
            }))
              .then(response => {
                if (response.data.page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = response.data.page
                  }
                } else if (page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = page
                  }
                }
                resolve({
                  data: response.data.data ? response.data.data : response.data.items,
                  count: response.data.meta.total,
                  page: response.data.meta.currentPage
                })
              })
              .catch(error => {
                if (!axios.isCancel(error)) {
                  reject(error)
                }
              })
              .finally(() => {
                this.isLoading = false
              })
          })
        },
        orderBy: {
          column: 'createdAt',
          ascending: false
        },
        saveState: false,
        storage: 'local',
        filterable: true,
        sortable: ['createdAt'],
        customFilters: ['entity'],
        headings: {
          createdAt: this.$t('leads.table.created_at'),
          name: this.$t('biosigns.columns.name'),
          entity: this.$t('biosigns.columns.entity'),
          actions: this.$t('tables.columns.actions')
        },
        columnsClasses: {
          createdAt: 'created_at',
          actions: 'actions'
        }
      },
      columns: ['createdAt', 'name', 'actions'],
      selectedAnamnese: null
    }
  },
  methods: {
    getTableReference: function () {
      return this.$refs.anamnesesTable
    },
    reload: function () {
      this.$refs.anamnesesTable.refresh()
    },
    onLoading: function () {
      this.$emit('loading')
    },
    onLoaded: function (state) {
      this.$emit('loaded', state)
    },
    handleRowClicked: function ({ row }) {
      let selectedAnamnese = row
      this.$router.push({name: `evohealth/evohealth/anamnesis-details/id`, params: {id: row.id, type: 'update'}})
      //this.$emit('leadClicked', selectedLead)
    },
    handleCreateAnamnese: function() {
      this.$router.push({name: `evohealth/evohealth/anamnesis-details/id`, params: {entity: this.filters.entity, type: 'create'}})
    },
    handleDeleteAnamnese: function(anamnese, event) {
      if (event) event.stopPropagation();
      this.selectedAnamnese = anamnese
      this.showDeleteConfirmationModal = true
    },
    destroyAnamnese: async function() {
      try {
        await EvohealthService.deleteAnamnese(this.selectedAnamnese.id)
      } catch (e) {
        console.log(e)
        if(e.response.status === 405) {
          this.showToast(this.$t('evohealth.anamneses.cannot_delete_anamnese_with_answers'), this.$store.state.errorToastOptions)
        } else {
          this.showToast(this.$t('auth.tfa.errors.generic'), this.$store.state.errorToastOptions)
        }
      } finally {
        this.reload()
        this.selectedAnamnese = null
        this.showDeleteConfirmationModal = false
      }
    },
    cancelDestroyAnamnese: function() {
      this.showDeleteConfirmationModal = false
      this.selectedAnamnese = null
    },
    handleCloneAnamnese: function(anamnese, event) {
      if (event) event.stopPropagation();
      this.selectedAnamnese = anamnese
      this.showCloneModal = true
    },
    cloneSuccessfull: function() {
      this.showCloneModal = false
      this.showToast(this.$t('evohealth.anamneses.anamnese_cloned_success'), this.$store.state.successToastOptions)
      this.reload()
    }
  },
  computed: {
    queryUrl: function() {
      return `${this.$store.state.evohealth_server}v1/anamneses`
    }
  },
  watch: {
    'filters.entity': {
      handler: function(value) {
        if (value) {
          this.emitTableFilter(`vue-tables.anamnesesTable.filter::entity`, value.id || '')
        }
      }
    }
  }

};
</script>

<style lang="scss">
.actions {
  text-align: center;
  justify-content: center;
}
</style>
